import { render, staticRenderFns } from "./preguntaItem.vue?vue&type=template&id=1d93e1c4&"
import script from "./preguntaItem.vue?vue&type=script&lang=js&"
export * from "./preguntaItem.vue?vue&type=script&lang=js&"
import style0 from "./preguntaItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports